module.exports = __webpack_public_path__ + "static/media/details.65a23fb9.png";